import React from 'react';
import PurchaseOrderViewListDrawerPresenter from './PurchaseOrderViewListDrawerPresenter';
import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';

interface Props {
  purchaseOrders: CapaQuotationRfqPurchaseOrder[];
  onClick: (purchaseOrderId: string) => void;
}
const PurchaseOrderViewListDrawerContainer = ({
  purchaseOrders,
  onClick
}: Props) => {
  return (
    <PurchaseOrderViewListDrawerPresenter
      purchaseOrders={purchaseOrders}
      onClick={onClick}
    />
  );
};

export default PurchaseOrderViewListDrawerContainer;
